export default __webpack_public_path__ + "static/media/close_md.577c17b2.svg";